export const SET_GOOGLE_DATA = "SET_GOOGLE_DATA";
export const SET_GOOGLE_DATA_NULL = "SET_GOOGLE_DATA_NULL";
export const SET_GOOGLE_DATA_PREVIOUS = "SET_GOOGLE_DATA_PREVIOUS";
export const SET_GOOGLE_DATA_PREVIOUS_NULL = "SET_GOOGLE_DATA_PREVIOUS_NULL";
